import React, { useEffect } from 'react'
import './scss/itserviceprovider.css'
import $ from 'jquery'
import Navbar from '../Comman_Layout/Header/Navbar'
import Footer from '../Comman_Layout/Footer/Footer'

const ItServiceProvider = () => {

    var current_fs, next_fs, previous_fs;
    var left, opacity, scale;
    var animating;


    useEffect(() => {
        $(".next").click(function () {
            // console.log('Next Clicked.')
            if (animating) return false;
            animating = true;
            current_fs = $(this).parent();
            next_fs = $(this).parent().next();
            $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
            next_fs.show();
            current_fs.animate(
                { opacity: 0 },
                {
                    step: function (now, mx) {
                        scale = 1 - (1 - now) * 0.2;
                        left = now * 50 + "%";
                        opacity = 1 - now;
                        current_fs.css({
                            transform: "scale(" + scale + ")",
                            position: "absolute"
                        });
                        next_fs.css({ left: left, opacity: opacity });
                    },
                    duration: 800,
                    complete: function () {
                        current_fs.hide();
                        animating = false;
                    },
                    // easing: "easeInOutBack"
                }
            );
        });

        $(".previous").click(function () {
            // console.log('previous Clicked.')
            if (animating) return false;
            animating = true;

            current_fs = $(this).parent();
            previous_fs = $(this).parent().prev();
            $("#progressbar li")
                .eq($("fieldset").index(current_fs))
                .removeClass("active");

            previous_fs.show();
            current_fs.animate(
                { opacity: 0 },
                {
                    step: function (now, mx) {
                        scale = 0.8 + (1 - now) * 0.2;
                        left = (1 - now) * 50 + "%";
                        opacity = 1 - now;
                        current_fs.css({ left: left });
                        previous_fs.css({
                            transform: "scale(" + scale + ")",
                            opacity: opacity
                        });
                    },
                    duration: 800,
                    complete: function () {
                        // current_fs.hide();
                        animating = false;
                    },
                    // easing: "easeInOutBack"
                }
            );
        });

        $(".submit").click(function () {
            console.log('Submit Clicked.');

            return false;
        });

    }, [])

    let handleSubmitForm = () => {
        console.log('Form is submitting')
    }


    return (
        <>
            <Navbar />
            <section className="service-provider my-5">
                <div className="container">
                    {/* ===============Tab Area Start=============== */}
                    <div className="form-tab-area">
                        <ul className="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Company</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Individual</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            {/* ===============Company Tab Area Start=============== */}
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div className="custm-form">
                                    <form id='multistepsform' onSubmit={handleSubmitForm}>
                                        {/* -----------Company Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Company Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Organization<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Organization' id="name_of_organisation" name='name_of_organisation' required />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">'Address for Correspondence<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Address for Correspondence' id='address' name='address' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Website<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Website' id='website' name='website'  />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Contact Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Contact Number' id='contact_no' name='contact_no' required/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Year of Commencement of Business<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Year of Commencement of Business' id='year_of_commencement' name='year_of_commencement' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Company GST Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Company GST Number' id='gst_no' name='gst_no'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Company PAN Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Company PAN Number' id='pan_no' name='pan_no'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Number of Technical Manpower<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Number of Technical Manpower' id='no_of_manpower' name='no_of_manpower'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Type of the Organization<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Type of the Organization' id='type_of_organisation' name='type_of_organisation'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Last Year Turnover<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Last Year Turnover' id='last_year_turnover' name='last_year_turnover' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">5 Major Clients of the Organization<span></span></label>
                                                    <input type="text" className='form-control' placeholder='5 Major Clients of the Organization' name='five_major_clients' id='five_major_clients'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Company Main Services<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Company Main Services' name='company_main_services' id='company_main_services' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Proprietor <span></span></label>
                                                    <input type="text" className='form-control' placeholder=' Partners / Directors / CEO' name='name_of_proprietor' id='name_of_proprietor'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Designation<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Designation' name='proprietor_designation' id='proprietor_designation'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Mobile Number' name='proprietor_mobile_no' id='proprietor_mobile_no' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">E-Mail Address<span></span></label>
                                                    <input type="text" className='form-control' placeholder='E-Mail Address' name='proprietor_email' id='proprietor_email'/>
                                                </div>
                                            </div>
                                            <input type="button" name="next" className="next action-button" value="Next" />
                                        </fieldset>

                                        {/* -----------Contact Person Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Contact Person Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Contact Person 1 Name<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Contact Person 1 Name' name='contact_person1_name' id='contact_person1_name' required/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Designation<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Designation' name='contact_person1_designation' id='contact_person1_designation'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">E-mail Address<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='E-mail Address' name='contact_person1_email' id='contact_person1_email' required/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Mobile Number' name='contact_person1_mobile' id='contact_person1_mobile'/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Contact Person 2 Name<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Contact Person 2 Name' name='contact_person2_name' id='contact_person2_name'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Designation<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Designation' name='contact_person2_designation' id='contact_person2_designation'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">E-mail Address<span></span></label>
                                                    <input type="text" className='form-control' placeholder='E-mail Address' name='contact_person2_email' id='contact_person2_email'/>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Mobile Number' name='contact_person2_mobile' id='contact_person2_mobile'/>
                                                </div>
                                            </div>

                                            <input type="button" name="previous" className="previous action-button" value="Previous" />

                                            <input type="button" name="next" className="next action-button" value="Next" />
                                        </fieldset>

                                        {/* -----------Bank Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Company Bank Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Organization<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Organization' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Bank Account Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Bank Account Number' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Bank<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Bank' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Branch<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Branch' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">IFSC Code<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='IFSC Code' />
                                                </div>
                                            </div>

                                            <input type="button" name="previous" className="previous action-button" value="Previous" />
                                            <input type="button" name="next" className="next action-button" value="Next" />
                                        </fieldset>

                                        {/* -----------Services Offered Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Services Offered Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile App Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">React Native</option>
                                                        <option value="Flutter">Flutter</option>
                                                        <option value="Kotlin Native">Kotlin Native</option>
                                                        <option value="Swift / Objective C">Swift / Objective C</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Back End Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Core PHP</option>
                                                        <option value="Flutter">Laravel</option>
                                                        <option value="Kotlin Native">Node JS</option>
                                                        <option value="Swift / Objective C">Dot Net</option>
                                                        <option value="Swift / Objective C">Java</option>
                                                        <option value="Swift / Objective C">Angular</option>
                                                        <option value="Swift / Objective C">Python</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Front End Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native"> HTML / CSS/ JS</option>
                                                        <option value="Flutter">React</option>
                                                        <option value="Kotlin Native">Angular</option>
                                                        <option value="Swift / Objective C">View JS</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">CMS Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Wordpress</option>
                                                        <option value="Flutter">Shopify</option>
                                                        <option value="Kotlin Native">Open Cart</option>
                                                        <option value="Swift / Objective C">Drupal</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Others</label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Gaming</option>
                                                        <option value="Flutter">Blockchain</option>
                                                        <option value="Kotlin Native">AI</option>
                                                        <option value="Swift / Objective C">ML</option>
                                                        <option value="Swift / Objective C">Metaverse</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <input type="button" name="previous" className="previous action-button" value="Previous" />
                                            <input type="submit" name="submit" className="submit action-button" value="Submit" />
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                            {/* ===============Company Tab Area End=============== */}

                            {/* ===============Individual Tab Area Start=============== */}
                            <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                <div className="custm-form">
                                    <form action="" id='multistepsform'>
                                        {/* -----------Basic Details------------ */}
                                        <fieldset>
                                            <div className="title mb-4">
                                                <h4>Basic Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Mobile Number' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">E-Mail Address<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='E-Mail Address' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Total Experience<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Total Experience' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Technology Stack<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Technology Stack' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Upload CV<span>*</span></label>
                                                    <input type="file" className='form-control form-select' placeholder='CV' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor=""> PAN Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder=' PAN Number' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Adhaar Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Adhaar Number' />
                                                </div>
                                            </div>
                                            <input type="button" name="next" className="next action-button" value="Next" />
                                        </fieldset>

                                        {/* -----------Bank Details------------ */}
                                        <fieldset>
                                            <div className="title mb-4">
                                                <h4>Bank Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Bank Account Number<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Bank Account Number' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Bank<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Bank' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Branch<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Branch' />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">IFSC Code<span>*</span></label>
                                                    <input type="text" className='form-control' placeholder='IFSC Code' />
                                                </div>
                                            </div>

                                            <input type="button" name="previous" className="previous action-button" value="Previous" />
                                            <input type="button" name="next" className="next action-button" value="Next" />
                                        </fieldset>

                                        {/* -----------Services Offered Details------------ */}
                                        <fieldset>
                                            <div className="title mb-4">
                                                <h4>Services Offered Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile App Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">React Native</option>
                                                        <option value="Flutter">Flutter</option>
                                                        <option value="Kotlin Native">Kotlin Native</option>
                                                        <option value="Swift / Objective C">Swift / Objective C</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Back End Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Core PHP</option>
                                                        <option value="Flutter">Laravel</option>
                                                        <option value="Kotlin Native">Node JS</option>
                                                        <option value="Swift / Objective C">Dot Net</option>
                                                        <option value="Swift / Objective C">Java</option>
                                                        <option value="Swift / Objective C">Angular</option>
                                                        <option value="Swift / Objective C">Python</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Front End Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native"> HTML / CSS/ JS</option>
                                                        <option value="Flutter">React</option>
                                                        <option value="Kotlin Native">Angular</option>
                                                        <option value="Swift / Objective C">View JS</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">CMS Development<span>*</span></label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Wordpress</option>
                                                        <option value="Flutter">Shopify</option>
                                                        <option value="Kotlin Native">Open Cart</option>
                                                        <option value="Swift / Objective C">Drupal</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Others</label>
                                                    <select name="" className='form-control form-select' id="">
                                                        <option value="React Native">Gaming</option>
                                                        <option value="Flutter">Blockchain</option>
                                                        <option value="Kotlin Native">AI</option>
                                                        <option value="Swift / Objective C">ML</option>
                                                        <option value="Swift / Objective C">Metaverse</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <input type="button" name="previous" className="previous action-button" value="Previous" />
                                            <input type="submit" name="submit" className="submit action-button" value="Submit" />
                                        </fieldset>

                                    </form>
                                </div>
                            </div>
                            {/* ===============Individual Tab Area End=============== */}
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </>

    )
}

export default ItServiceProvider